module.exports = __webpack_public_path__ + "img/90dc9.1e305b16.svg";